import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const VideoFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M12 2.46c-5.27 0-9.54 4.27-9.54 9.54s4.27 9.54 9.54 9.54 9.54-4.27 9.54-9.54S17.27 2.46 12 2.46Zm3.19 10.07L12.98 14l-2.01 1.34c-.43.29-1-.02-1-.54V9.18c0-.52.57-.82 1-.54l2.01 1.34 2.21 1.47c.38.26.38.82 0 1.07v.01Z"
      fill={color}
    />
  </Svg>
)

export default VideoFilled
